"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CriticalNotificationSeverityEnum = void 0;
var CriticalNotificationSeverityEnum;
(function (CriticalNotificationSeverityEnum) {
    CriticalNotificationSeverityEnum["Info"] = "info";
    CriticalNotificationSeverityEnum["Warning"] = "warning";
    CriticalNotificationSeverityEnum["Critical"] = "critical";
})(CriticalNotificationSeverityEnum = exports.CriticalNotificationSeverityEnum || (exports.CriticalNotificationSeverityEnum = {}));
//# sourceMappingURL=critical-notification-severity-enum.js.map